<!-- communication-preferences-popup.component.html -->
<div class="dialog-container">
  <div class="dialog-header">
    <h2
      data-translation-key="communication_preferences_communication_preferences"
    >
      {{ 'communication_preferences.communication_preferences' | translate }}
    </h2>
  </div>

  <app-communication-preferences-matrix
    [data]="data"
  ></app-communication-preferences-matrix>
</div>
